/* eslint-disable jira/filename-case */
import type { ComponentType } from 'react';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import {
	createLayout,
	withProjectContext,
	type Layout,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { ProjectRouteListener } from '@jira/platform__utils-route-analytics/src/ui/project-route-listener/index.tsx';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const withAnyProjectContext = (Component: ComponentType<Record<any, any>>) =>
	withProjectContext(Component, {
		project: {
			style: 'any',
			type: 'any',
		},
	});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const ProjectTrackers = lazyAfterPaint(
	() => import(/* webpackChunkName: "async-project-trackers" */ './ui/trackers/Trackers.tsx'),
	{
		ssr: false,
	},
);

const rightSidebars = () => [];

const globalComponents = [
	withAnyProjectContext(ProjectTrackers),
	withAnyProjectContext(ProjectRouteListener),
];

export const projectLayout: Layout = createLayout({
	globalComponents,
	rightSidebars: rightSidebars(),
});
